export function disableLogBuffer(): void {
  return;
}
